export default {
    //金额
    price:(val)=>{
        const reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
        return reg.test(val);
    },
    //纯数字
    onlyNumber(val){
        const reg = /^[0-9]*$/;
	    return reg.test(val);
    },
    //邮箱
    email:(val)=> {
        const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
        return reg.test(val);
    },
    // 名称校验
    checkName(val){
        const reg = /^(?:[\u4e00-\u9fa5]+)(?:●[\u4e00-\u9fa5]+)*$|^[a-zA-Z0-9]+\s?[\.·\-()a-zA-Z]*[a-zA-Z]+$/;
        return reg.test(val)
    },
    // 手机号校验
    checkMobilePhone(val){
        const reg = /^(\+?0?86\-?)?1\d{10}$/;
        return reg.test(val)
    },
    //固定电话校验
    telephone(val){
        const reg = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
        return reg.test(val);
    },
    //百分比校验
    percent(val){
        const reg = /^(100|[1-9]?\d(\.\d\d?\d?)?)%$|0$/;
        return reg.test(val);
    }
}
